import { useInView } from "../../../hooks/useInView";
import { Link } from "react-router-dom";
import { useSiteContent } from "@/cms/SiteContentContext";
import { editableAttrs } from "@/cms/previewUtils";

const ServicesSection = () => {
  const { ref, inView } = useInView();
  const { content } = useSiteContent();
  const section = content.home.services;
  const services = content.services.items;

  return (
    <section id="services" className="bg-zinc-950 py-20 md:py-28" {...editableAttrs("home.services", "object")}>
      <div className="max-w-7xl mx-auto px-6">
        <div ref={ref} className="text-center mb-14">
          <span className="text-red-500 text-xs font-semibold tracking-widest uppercase" style={{ fontFamily: "Rajdhani, sans-serif" }} {...editableAttrs("home.services.badge", "text")}>
            {section.badge}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-3 section-title-line-center" style={{ fontFamily: "Rajdhani, sans-serif" }} {...editableAttrs("home.services.title", "text")}>
            {section.title}
          </h2>
          <p className="text-zinc-400 text-base mt-6 max-w-xl mx-auto" {...editableAttrs("home.services.description", "textarea")}>
            {section.description}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" {...editableAttrs("services.items", "array")}>
          {services.map((service, idx) => (
            <div
              key={service.id}
              className="service-card group bg-zinc-900 overflow-hidden cursor-pointer"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateY(0)" : "translateY(24px)",
                transition: `opacity 0.5s ease ${idx * 0.07}s, transform 0.5s ease ${idx * 0.07}s`,
              }}
              {...editableAttrs("services.items", "array")}
            >
              <div className="relative overflow-hidden h-48" {...editableAttrs(`services.items.${idx}.img`, "image")}>
                <img
                  src={service.img}
                  alt={service.title}
                  className={`service-img w-full h-full object-cover ${service.id === "02" ? "object-[50%_35%]" : "object-center"} transition-transform duration-500`}
                  {...editableAttrs(`services.items.${idx}.img`, "image")}
                />
                <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-zinc-900 via-zinc-900/30 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="service-number text-4xl font-bold text-white/20 transition-colors duration-300" style={{ fontFamily: "Rajdhani, sans-serif" }}>
                    {service.id}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 w-9 h-9 flex items-center justify-center bg-red-600/20 border border-red-600/40 group-hover:bg-red-600 transition-all duration-300">
                  <i className={`${service.icon} text-red-400 group-hover:text-white text-base`}></i>
                </div>
              </div>

              <div className="p-5">
                <h3 className="text-white font-bold text-lg mb-2 group-hover:text-red-400 transition-colors" style={{ fontFamily: "Rajdhani, sans-serif" }} {...editableAttrs(`services.items.${idx}.title`, "text")}>
                  {service.title}
                </h3>
                <p className="text-zinc-400 text-sm leading-relaxed" {...editableAttrs(`services.items.${idx}.desc`, "textarea")}>
                  {service.desc}
                </p>
                <Link to={`/hizmetler/${service.slug}`} className="inline-flex items-center gap-2 mt-4 text-red-500 hover:text-red-400 text-sm font-semibold transition-colors">
                  <span style={{ fontFamily: "Rajdhani, sans-serif" }}>Detaylı Bilgi</span>
                  <i className="ri-arrow-right-line text-sm"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
